import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useRef, useState } from "react";
import styled, { useTheme } from "styled-components";
import { escapeHTML, linkIfy } from "../libs/utilities";
import TranslationContext from "../providers/TranslationContext";
import withComponentOverride from "../withComponentOverride";
import DefaultMessageItem from "./MessageItem";
const MessageItem = withComponentOverride(DefaultMessageItem);
const MessagesContainer = withComponentOverride(styled.div `
	width: 100%;
	position: relative;
	overflow-y: auto;

	${({ theme: { variant } }) => {
    if (variant === "desktop") {
        return `
			padding: 16px;
			height: calc(100% - 26px);
					
			scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
			scrollbar-width: thin;
		
			::-webkit-scrollbar {
				width: 6px;
			}
		
			::-webkit-scrollbar-track {
				background: transparent;
				border-radius: 3px;
			}
		
			::-webkit-scrollbar-thumb {
				border-radius: 3px;
				background-color: rgba(0, 0, 0, 0.2);
				cursor: pointer;
			}
		
			::-webkit-scrollbar-thumb:hover,
			::-webkit-scrollbar-thumb:active {
				background-color: rgba(0, 0, 0, 0.3);
			}
			`;
    }
    return `
		height: 100%;
		padding: 10px 20px 0 20px;`;
}};

	font-size: ${({ fontSize }) => fontSize}px;
`);
const MessagesList = withComponentOverride(styled.div `
	position: relative;
	display: flex;
	width: 100%;
	min-height: 100%;
	gap: 16px;
	justify-content: flex-end;
	flex-direction: ${({ theme: { variant } }) => {
    return variant === "desktop" ? "column" : "column-reverse";
}};
`);
const HeaderContainer = withComponentOverride(styled.div `
	flex: 1 1 auto;
`);
const Header = withComponentOverride(styled.div `
	background-color: ${({ theme }) => theme.colors.headerBg};
	border-radius: 4px;
	color: ${({ theme }) => theme.colors.headerColor};
	font-size: ${({ fontSize }) => fontSize}px;
	font-weight: 400;
	margin: 0 0 16px 0;
	padding: 16px;
	text-align: center;
	width: 100%;

	b,
	strong {
		color: ${({ theme }) => theme.colors.headerColorBold};
	}
`);
const Messages = ({ lastMessage, fontSize, isTyping = false, defaultMessages = [], showHeader = false, showAdditionalMessages = false, }) => {
    const [messageHistory, setMessageHistory] = useState(defaultMessages);
    const { headerText, welcomeText } = useContext(TranslationContext);
    const { variant, components } = useTheme();
    const messagesContainerRef = useRef(null);
    if (lastMessage != null && messageHistory[messageHistory.length - 1] !== lastMessage) {
        setMessageHistory((prev) => {
            return [...prev, lastMessage];
        });
    }
    useEffect(() => {
        if (variant === "desktop" && messagesContainerRef?.current?.scrollTo) {
            messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
        }
    }, [messageHistory, messagesContainerRef, variant, isTyping]);
    return (_jsx(MessagesContainer, { fontSize: fontSize, ref: messagesContainerRef, componentOverride: components?.MessagesContainer, children: _jsxs(MessagesList, { componentOverride: components?.MessagesList, isTyping: isTyping, children: [showHeader && headerText && (_jsx(HeaderContainer, { componentOverride: components?.HeaderContainer, children: _jsx(Header, { fontSize: fontSize, componentOverride: components?.Header, children: headerText }) })), _jsx(MessageItem, { type: "welcome", fontSize: fontSize, componentOverride: components?.MessageItem, children: welcomeText }), messageHistory.map(({ message, additionalMessage, type, nick, id }) => {
                    return (_jsx(MessageItem, { type: type, nick: nick, fontSize: fontSize, additionalMessage: showAdditionalMessages && additionalMessage && linkIfy(escapeHTML(additionalMessage)), componentOverride: components?.MessageItem, children: linkIfy(escapeHTML(message)) }, id));
                })] }) }));
};
export default Messages;
